<template lang='pug'>
//- Analysis健檢分析結果
div(:class='$style[`cc-popbox-record-detail`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(v-if='preloading' :class='$style[`cc-record-detail-result`]')
    div(:class='$style[`cc-record-detail-empty`]')
      IconLoading(:size='50' :color='`#b1b1b1`')

  div(v-else :class='$style[`cc-record-detail-result`]')
    div(:class='$style[`cc-record-detail-vendor`]')
      div(:class='$style[`cc-record-detail-vendor-block`]')
        div(:class='$style[`cc-vendor-profile-thumb`]')
          figure(:class='$style[`cc-vendor-profile-thumb-photo`]')
            img(
              :src='avatarSrcLink(profile.vendor_thumb)'
              width='100%'
              height='100%')
        div(:class='$style[`cc-vendor-profile-info`]')
          .font-medium(:class='$style[`cc-vendor-profile-suitable`]') {{ profile.vendor }}
          .font-bold(:class='$style[`cc-vendor-profile-name`]') {{ profile.form_name }}

    //- 完成後總結報告
    div(:class='$style[`cc-record-detail-epro`]')
      div(:class='$style[`cc-record-detail-epro-block`]')
        div(:class='$style[`cc-epro-submit`]')
          section(v-if='Object.keys(analysis).length' :class='$style[`cc-epro-submit-analysis`]')
            header(:class='$style[`cc-epro-submit-analysis-head`]')
              span.font-bold Dr.Cell 健檢分析
            div(:class='$style[`cc-epro-submit-analysis-block`]')
              div(:class='$style[`cc-epro-submit-analysis-broadcast`]')
                div(:class='$style[`cc-epro-submit-analysis-broadcast-info`]')
                  span.font-bold(v-if='profile.alert_level <= 1' :class='$style[`good-status`]') 您的狀態很好
                  span.font-bold(v-else-if='profile.alert_level === 2' :class='$style[`warn-status`]') 需持續留意觀察
                  span.font-bold(v-else-if='profile.alert_level === 3' :class='$style[`bad-status`]') 症狀嚴重，盡快改善
                  span.font-bold(v-if='analysis.broadcast') {{ analysis.broadcast }}
                div(:class='$style[`cc-epro-submit-analysis-broadcast-controller`]')
                  button(
                    tabindex='0' aria-label='瀏覽健檢報告'
                    :class='$style[`cc-epro-submit-analysis-controller-btn`]'
                    @click='popShowAnalysisDetail')
                    IconSearch(:size='16' :color='`#fff`')
                    span 瀏覽健檢報告

          section(v-if='core.length' :class='$style[`cc-epro-submit-form`]')
            header(:class='$style[`cc-epro-submit-form-caption`]')
              div(:class='$style[`flex-2`]')
                span.font-bold 核心項目
              div(:class='$style[`flex-1`]')
                span.font-bold 您的回答

            ul(:class='$style[`cc-epro-submit-form-ul`]')
              li(v-for='items, index in core' :key='index' :class='$style[`cc-epro-submit-form-li`]')
                div(:class='[$style[`cc-epro-submit-form-question`], $style[`flex-2`]]')
                  span {{ items.question_content }}
                div(v-if='items.question_type === `date-picker`' :class='[$style[`cc-epro-submit-form-result`], $style[`flex-1`]]')
                  span.font-bold {{ items.answer ? transformDateMoment(items.answer) : '-' }}
                div(v-else-if='items.question_type === `photo-upload`' :class='[$style[`cc-epro-submit-form-result`], $style[`flex-1`]]')
                  button(
                    v-if='items.photo'
                    tabindex='0' aria-label='點擊放大'
                    :class='$style[`cc-epro-submit-form-result-btn`]'
                    @click='handleClickZoomPhoto(`${SERVER_STATIC_URL}media/${items.photo}`)')
                    IconSearch(:size='12' :color='`#262626`')
                    span(:class='$style[`cc-epro-submit-form-result-zoom`]') 瀏覽照片
                  span(v-else) -

                div(v-else :class='[$style[`cc-epro-submit-form-result`], $style[`flex-1`]]')
                  span.font-bold {{ items.answer ? items.answer : '-' }}
              li(v-if='profile.action_score' :class='$style[`cc-epro-submit-form-li`]' style='justify-content: flex-end;')
                div(:class='$style[`cc-epro-submit-form-li-action-score`]')
                  span.font-bold 核心項目總分
                  CountAnimate(:number='analysis.score' :delay='600')

          section(v-if='basic' :class='$style[`cc-epro-submit-form`]')
            header(:class='$style[`cc-epro-submit-form-caption`]')
              div(:class='$style[`flex-2`]')
                span.font-bold 個人化項目
              div(:class='$style[`flex-1`]')
                span.font-bold 您的回答

            //- 固定的基礎項目
            ul(:class='$style[`cc-epro-submit-form-ul`]')
              li(v-if='profile.se_date' :class='$style[`cc-epro-submit-form-li`]')
                div(:class='[$style[`cc-epro-submit-form-question`], $style[`flex-2`]]')
                  span 本次的記錄日期
                div(:class='[$style[`cc-epro-submit-form-result`], $style[`flex-1`]]')
                  span.font-bold {{ profile.se_date ? profile.se_date : '-' }}

              li(v-if='basic.se_weight' :class='$style[`cc-epro-submit-form-li`]')
                div(:class='[$style[`cc-epro-submit-form-question`], $style[`flex-2`]]')
                  span 您的體重(公斤)
                div(:class='[$style[`cc-epro-submit-form-result`], $style[`flex-1`]]')
                  span.font-bold {{ basic.se_weight ? basic.se_weight : '-' }}

              li(v-if='basic.se_fever' :class='$style[`cc-epro-submit-form-li`]')
                div(:class='[$style[`cc-epro-submit-form-question`], $style[`flex-2`]]')
                  span 是否發燒超過38度(攝氏)
                div(:class='[$style[`cc-epro-submit-form-result`], $style[`flex-1`]]')
                  span.font-bold {{ basic.se_fever ? basic.se_fever : '-' }}

              li(v-if='basic.se_now_treatment' :class='$style[`cc-epro-submit-form-li`]')
                div(:class='[$style[`cc-epro-submit-form-question`], $style[`flex-2`]]')
                  span 正在接受的治療?(可多選)
                div(:class='[$style[`cc-epro-submit-form-result`], $style[`flex-1`]]')
                  span.font-bold {{ basic.se_now_treatment ? basic.se_now_treatment : '-' }}

              //- li(v-if='basic.se_qualitylife' :class='$style[`cc-epro-submit-form-li`]')
              //-   div(:class='[$style[`cc-epro-submit-form-question`], $style[`flex-2`]]')
              //-     span 生活品質(越高越好)
              //-   div(:class='[$style[`cc-epro-submit-form-result`], $style[`flex-1`]]')
              //-     span.font-bold {{ basic.se_qualitylife ? basic.se_qualitylife : '-' }}

              //- li(v-if='basic.se_painlevel' :class='$style[`cc-epro-submit-form-li`]')
              //-   div(:class='[$style[`cc-epro-submit-form-question`], $style[`flex-2`]]')
              //-     span 疼痛指數(越高越痛)
              //-   div(:class='[$style[`cc-epro-submit-form-result`], $style[`flex-1`]]')
              //-     span.font-bold {{ basic.se_painlevel ? basic.se_painlevel : '-' }}

              //- li(v-if='basic.se_emotion' :class='$style[`cc-epro-submit-form-li`]')
              //-   div(:class='[$style[`cc-epro-submit-form-question`], $style[`flex-2`]]')
              //-     span 心情狀態(越高越好)
              //-   div(:class='[$style[`cc-epro-submit-form-result`], $style[`flex-1`]]')
              //-     span.font-bold {{ basic.se_emotion ? basic.se_emotion : '-' }}

      div(:class='$style[`cc-record-detail-epro-control`]')
        button(
          title='刪除紀錄'
          tabindex='0' aria-label='刪除紀錄'
          :class='$style[`cc-record-detail-epro-control-delete`]'
          @click='deleteEproRecord')
          IconTrash(:size='24' :color='`#d8374d`')
          span 刪除紀錄

        button.btn-extra(
          title='關閉'
          tabindex='0' aria-label='關閉'
          :class='$style[`cc-record-detail-epro-control-close`]'
          @click='handleClosePopBox')
          span 關閉

</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
// var emitter = require('tiny-emitter/instance');
import moment from 'moment';
import IconLoading from '../../icon/Loading';
import IconSearch from '../../icon/Search';
import IconTrash from '../../icon/Trash';

// import { debounce } from 'debounce';
// import GlobalEmitter from 'tiny-emitter/instance';

import {
  getLoadSideEffectRecordDetail,
} from '../../../js/restapi';

export default {
  components: {
    IconLoading,
    IconSearch,
    IconTrash,
  },

  props: {
    recordId: null,
  },

  data() {
    return {
      preloading: true,
      profile: {},
      basic: {},
      core: [],
      analysis: {},
    };
  },

  created() {
    if (this.loginStatus) {
      this.axiosLoadUserRecordDetail();
    }
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopZoomStatus: 'global/POPZOOM_STATUS',
      changePopDeleteEproStatus: 'global/POPDELETE_EPRO_STATUS',
      changePopEproRecordStatus: 'global/POPEPRO_RECORD_DETAIL',
      changePopAnalysisStatus: 'global/POPANALYSIS_STATUS',
    }),

    handleClickZoomPhoto(src) {
      this.changePopZoomStatus({
        active: true,
        src,
      });
    },

    handleClosePopEproRecordDetail() {
      // this.updateKey += 1;
      this.$router.push({
        name: 'effect-record',
      }).catch(() => {});

      this.changePopEproRecordStatus({
        active: false,
        recordId: null,
      });
    },

    deleteEproRecord() {
      this.changePopDeleteEproStatus({
        active: true,
        id: this.recordId,
      });
    },

    popPreviewModeWarning() {
      this.changePopBoxStatus({
        active: true,
        include: 'warnEproPreviewMode',
      });
    },

    popShowAnalysisDetail() {
      this.changePopAnalysisStatus({
        active: true,
        detail: {
          id: this.analysis.id,
          broadcast: this.analysis.broadcast,
          category: this.analysis.category,
          course: this.analysis.course,
          evaluate: this.analysis.evaluate,
          prediction: this.analysis.prediction,
          reminder: this.analysis.reminder,
          start_date: this.analysis.start_date,
          suggestion: this.analysis.suggestion,
          summary: JSON.parse(this.analysis.summary.replace(/'/g, '"')),
          vertex_source: this.analysis.vertex_source ? JSON.parse(this.analysis.vertex_source.replace(/'/g, '"')) : null,
        },
      });
    },

    axiosLoadUserRecordDetail() {
      console.log('this.loginDjangoId', this.loginDjangoId);
      getLoadSideEffectRecordDetail('', { record_id: this.recordId })
        .then((res) => {
          console.log('讀取副作用詳細資料 Success', res);
          this.profile = res.data.profile;
          this.basic = res.data.basic;
          this.core = res.data.core;
          this.analysis = res.data.analysis;

          this.preloading = false;
        })
        .catch((err) => {
          console.log('讀取副作用詳細資料 Error', err);
          this.$router.replace({
            name: 'error404',
          }).catch(() => true);
        });
    },

    transformDateMoment(date) {
      return moment(new Date(date)).format('YYYY.MM.DD');
    },

    joinArrayToString(arr) {
      return arr.join(',');
    },

    handleClosePopBox() {
      this.$router.push({
        name: 'effect-record',
      }).catch(() => {});

      this.changePopEproRecordStatus({
        active: false,
        recordId: null,
      });
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      loginStatus: 'user/exportLoginStatus',
      // subscribeVip: 'user/exportUserSubscribeVip',
      // loginProfile: 'user/exportUserProfile',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popEproRecordDetail.scss';
</style>
